module.exports = __webpack_public_path__ + "static/media/11.1c5580ef.png";